import { render, staticRenderFns } from "./GapAnalysis.vue?vue&type=template&id=81195c98&scoped=true&"
import script from "./GapAnalysis.vue?vue&type=script&lang=js&"
export * from "./GapAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./GapAnalysis.vue?vue&type=style&index=0&id=81195c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81195c98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VProgressCircular})
